const TEMPLATE_NAME = 'ROUTING_MAP';

const initialState = () => ({
  loading: false,
  roadmap: [],
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true,
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false,
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const roadmap = action.payload.roadmap;
      return {
        ...state,
        loading: false,
        roadmap: roadmap,
      };
    }

    default:
      return state;
  }
};

export default reducer;
